import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';
import { User } from '@/modules/user/models/User';
import { Team } from '@/modules/team/models/Team';
import { TeamRole } from '@/modules/team/constants/TeamRole';

export class TeamUser extends BaseEntityModel {
  public id?: number;
  public teamId?: number;
  public userId?: number;
  public role?: TeamRole;
  public user: Relationship<User> | null;
  public team: Relationship<Team> | null;

  constructor(model: Partial<TeamUser> = {}) {
    super(model);

    this.id = model.id;
    this.teamId = model.teamId;
    this.userId = model.userId;
    this.role = model.role as TeamRole;
    this.user = User.mapModelOrNull(model.user);
    this.team = Team.mapModelOrNull(model.team);
  }
}
